module.exports = __webpack_public_path__ + "static/media/keeperdao.3b2d9eaf.svg";